<template>
  <div class="app-container">
    <div class="flx-between">
      <div class="flex">
        <el-button
          v-permit:remove="'btn:receivableManagementSite:billCollection:export'" size="small" type="primary"
          @click="operationBtn"
        >
          {{ $t('receivablePayable.Export') }} <!--导出-->
        </el-button>
        <!--自定义栏目-->
        <CustomStatusBar
          :columns-data="DETAIL_TABLE_HEADER"
          :params="searchParams"
          :save-params="customParams"
          @updateColumns="updateColumns"
        />
      </div>
      <!--查询-->
      <el-button
        icon="el-icon-search" size="small" type="primary"
        @click="searchResources()"
      >{{ $t('receivablePayable.Search') }}
      </el-button>
    </div>
    <el-divider />
    <div v-loading="alertLoading" class="alert">
      <i class="el-icon-info icon" />
      <p>
        <span class="title">{{ $t('orderCenterCont.TotalCost') }}： </span>
        <span class="num">{{ totalFeeHead }}</span>
        <span v-if="totalFeeHeadItem&&Object.keys(totalFeeHeadItem).length" class="signal"> | </span>
      </p>
      <p v-for="(value, key, index) in totalFeeHeadItem" :key="index">
        <span class="title">{{ key }}：</span>
        <span class="num">{{ value }}</span>
        <span v-if="Object.keys(totalFeeHeadItem).length-1>index" class="signal"> | </span>
      </p>
    </div>
    <div>
      <TableCmp
        :table-data="tableData"
        :current-columns="currentColumns"
        :get-current-columns="getCurrentColumns"
        :page-number="queryForm.pageNumber"
        :page-size="queryForm.pageSize"
        :is-withdraw="false"
        @selection-change="handleSelectionChange"
      />
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getExamineTableData"
          @size-change="getExamineTableData"
        />
      </div>
    </div>
    <!--  查询  -->
    <el-drawer
      :append-to-body="true"
      :title="$t('receivablePayable.Search')"
      :visible.sync="showSearch"
      custom-class="drawerClass"
      direction="rtl"
      size="50%"
    >
      <SearchForm
        :is-read-only="true"
        :select-key="2"
        :bill-batch-number="batchNumber"
        :handler-id="handlerId"
        @search="searchFun"
        @close="showSearch = false"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import {
  apiExportCustomerBills,
  apiSiteExpenseExpenseSubTotal,
  apiSiteExpenseGetPage
} from '@/api/finance/receivables';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { CARGO_TYPE } from '@/views/finance/basicData/quotationManagement/cmp/utils';
import { BH_ORDER_TYPE_LIST, WAYBILL_STATUS, ORDER_TYPE_LIST, getIsAuth } from '@/views/finance/utils';
import { QUERY_PARAMS } from '@/views/finance/receivableManagementSite/aRGenerationNew/utils';
import { DETAIL_TABLE_HEADER } from '@/views/finance/receivableManagementSite/billCollection/utils';
import { cloneDeep } from 'lodash-es';

export default {
  components: {
    CustomStatusBar: () => import('@/components/customStatusBar/index.vue'),
    SearchForm: () => import('@/views/finance/receivableManagementSite/cmp/searchForm/index.vue'),
    TableCmp: () => import('@/views/finance/receivableManagementSite/cmp/table.vue')
  },
  props: {
    batchNumber: {
      type: String,
      default: ''
    },
    billBatchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      CARGO_TYPE,
      // 物流订单
      WAYBILL_STATUS,
      // 揽收订单
      ORDER_TYPE_LIST,
      // 备货揽收订单
      BH_ORDER_TYPE_LIST,
      DETAIL_TABLE_HEADER,
      queryForm: {
        orderDirection: 'DESC',
        orderProperty: '',
        pageNumber: 1,
        pageSize: 10,
        params: {
          ...QUERY_PARAMS
        }
      },
      total: 0,
      tableData: [],
      currentColumns: [],
      getCurrentColumns: [],
      selectData: [],
      showSearch: false,
      tableHeight: 0,
      totalFee: 0,
      searchParams: {
        type: 0,
        menuEnum: 'companyToSiteCollectionDetails'
      },
      customParams: {
        templateField: '',
        templateName: '应收账单核收详情',
        type: 0,
        menuEnum: 'companyToSiteCollectionDetails',
        userId: ''
      },
      handlerId: '',
      totalFeeHead: null, // 费用总计
      totalFeeHeadItem: {}, // 费用详细列表
      alertLoading: false // 总费用loading
    };
  },

  created() {
    this.createUser = getUserIdAndNameObj();
    this.tableHeight = document.body.clientHeight - 220;
    this.queryForm.params.receiptNumber = this.batchNumber;
    this.getExamineTableData();
    this.getExpenseSubTotal();

    // 经办人是否存在禁用，如果禁用则只能查看当前当前登陆人
    {
      const isBool = getIsAuth('btn:aRGeneration:onlyAgent');
      if (isBool) {
        this.handlerId = this.$store.getters.userId;
      }
    }
  },
  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 260;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 260;
    };
  },
  methods: {
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
      });
    },
    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },
    // 操作
    operationBtn() {
      const ids = [];
      this.selectData.map(list => {
        ids.push(list.id);
      });
      const prop = [];
      const label = [];
      this.currentColumns.forEach(item => {
        if (item.prop !== 'customerAlias') {
          prop.push(item.prop);
          label.push(item.label);
        }
      });
      const param = {
        ...this.queryForm.params,
        fieldList: prop,
        headList: label,
        ids: ids
      };
      apiExportCustomerBills(param).then(res => {
        if (res.code === 200) {
          return goResourceTaskList();
        }
      }).then(res => {
        if (res) {
          this.$emit('closeDetail');
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 打开查询弹窗
    searchResources() {
      this.queryForm.params.receiptNumber = this.batchNumber;
      this.showSearch = true;
    },
    // 获取列表
    getExamineTableData() {
      const param = cloneDeep(this.queryForm);
      this.getCurrentColumns = [];
      // 获取列表数据
      apiSiteExpenseGetPage(param).then(resp => {
        if (resp.code === 200) {
          this.tableData = resp.data.map(arr => {
            // 物流订单 WAYBILL_STATUS    揽收订单 ORDER_TYPE_LIST  备货揽收订单 BH_ORDER_TYPE_LIST
            if ((arr.businessType === 0 || arr.businessType === 7) && arr.status) {
              /**
               * 1、业务类型 businessType 为 0，订单状态展示【物流订单】的运单状态
               */
              const s1 = this.WAYBILL_STATUS.find(item => item.code === arr.status) || '';
              arr.status = s1.label;
            } else if (arr.businessType === 1 && arr.collectionCategory === 0 && arr.status) {
              /**
               * 2、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 0，订单状态展示【揽收订单】的订单状态
               */
              const s2 = this.ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s2.collectStatusName;
            } else if (arr.businessType === 1 && arr.collectionCategory === 1 && arr.status) {
              /**
               * 3、业务类型 businessType 为 1，且揽收类别 collectionCategory 为 1，订单状态展示【备货揽收订单】的订单状态
               */
              const s3 = this.BH_ORDER_TYPE_LIST.find(item => item.collectStatus === arr.status) || '';
              arr.status = s3.collectStatusName;
            } else {
              arr.status = '';
            }
            return arr;
          });
          this.total = resp.total;
          if (resp.data.length > 0) {
            this.getCurrentColumns = [];
            resp.columns.map(item => {
              const obj = {
                prop: item.prop,
                label: item.label.split('_')[0],
                width: 160,
                fixed: 'left',
                highlight: false
              };
              this.getCurrentColumns.push(obj);
            });
          }
        }
      }).catch(err => {
        console.error(err);
      });
    },
    // 查询
    searchFun(params) {
      console.log(params, '查询条件');
      this.showSearch = false;
      Object.assign(this.queryForm.params, { ...params });
      this.queryForm.pageNumber = 1;
      this.getExamineTableData();
    },
    /**
     * @description 获取费用统计
     */
    getExpenseSubTotal() {
      this.alertLoading = true;
      const param = cloneDeep(this.queryForm.params);
      apiSiteExpenseExpenseSubTotal(param)
        .then((res) => {
          console.log(res.data);
          this.totalFeeHead = res.data.totalFee;
          this.totalFeeHeadItem = res.data.itemFee;
        }).finally(() => {
          this.alertLoading = false;
        });
    }
  }
};
</script>

